import { RoutingConfig } from '@spartacus/core';

export const routingConfig: RoutingConfig = {
  routing: {
    routes: {
      home: {
        paths: [''],
        protected: false
      },
      notFound: {
        paths: ['not-found'],
        protected: false
      },
      // plp routes
      search: {
        paths: ['search/:query']
      },

      category: {
        paths: ['category/:categoryCode'],
        paramsMapping: { categoryCode: 'code' },
        protected: false
      },

      // pdp routes
      product: {
        paths: ['p/:productCode'],
        paramsMapping: { productCode: 'code' },
        protected: false
      },

      termsAndConditions: {
        paths: ['downloads-certificates'],
        protected: false
      },
      storeFinder: {
        paths: ['support/find-us'],
        protected: false
      },
      contactUs: {
        paths: ['support/contact'],
        protected: false
      }
    },
    protected: false
  }
};
